"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const Integral_1 = __importDefault(require("./Integral"));
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const emptyData = { integrals: {}, info: {}, display: {} };
function IntegralsSeries() {
    const { displayerKey, view: { spectra: { activeTab: nucleus }, }, } = (0, ChartContext_1.useChartData)();
    const spectrum = (0, useSpectrum_1.default)(emptyData);
    if (!spectrum.integrals?.values ||
        !spectrum.display.isVisible ||
        spectrum.info?.isFid) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: (0, jsx_runtime_1.jsx)("g", { className: "integrals", children: spectrum.integrals.values.map((integral) => ((0, jsx_runtime_1.jsx)(Integral_1.default, { nucleus: nucleus, integral: integral }, integral.id))) }) }));
}
exports.default = IntegralsSeries;
